import { memo, useEffect } from "react";
import HealthIncNotificaMessageBody from "../HealthIncNotificaMessageBody/HealthIncNotificaMessageBody";
import { useAllRelatives } from "../../../../customHooks/useAllRelatives";

function HealthIncNotificaForHrToReviewUploadedRelData() {

const { handleGetRelativesData , searchResult } = useAllRelatives();    

//====State start here====

//====State end here====

//====useEffect start here====
useEffect(()=>{
    handleGetRelativesData("","WAITING",1);
},[]);
//====useEffect end here====
return (
<>
{
 ( searchResult && searchResult.length !== 0 ) &&
 (<div className='show_notifi_container'> 
  <HealthIncNotificaMessageBody 
    notifText = {"بعض بيانات التأمين الصحي بحاجة الى مراجعة"} 
    btnText = {"انتقال"}
    btnLink = {"/emp/h_insurance_manage_relatives_data"}
   /> 
  </div>
   )
}
</>);
}

export default memo(HealthIncNotificaForHrToReviewUploadedRelData);